/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FreeInputs */

const en_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const es_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const fr_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuit`)
};

const de_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos`)
};

const ja_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料`)
};

const zh_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费`)
};

const ar_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجاناً`)
};

const id_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const it_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const ru_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатно`)
};

const pt_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grátis`)
};

const ko_free = /** @type {(inputs: FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {FreeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const free = /** @type {((inputs?: FreeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FreeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_free(inputs)
	if (locale === "es") return es_free(inputs)
	if (locale === "fr") return fr_free(inputs)
	if (locale === "de") return de_free(inputs)
	if (locale === "ja") return ja_free(inputs)
	if (locale === "zh") return zh_free(inputs)
	if (locale === "ar") return ar_free(inputs)
	if (locale === "id") return id_free(inputs)
	if (locale === "it") return it_free(inputs)
	if (locale === "ru") return ru_free(inputs)
	if (locale === "pt") return pt_free(inputs)
	return ko_free(inputs)
});